import { fullstoryEvent } from '@/fullstory/utils/fullstory-event';
import { useRouteError } from 'react-router';
import { useEffect } from 'react';
import { logger } from '~/logger/logger';

export default function useReportErrorBoundary() {
  const error = useRouteError();

  useEffect(() => {
    let reportError: NodeJS.Timeout | undefined;

    // If we see an error, wait for render cycle to settle and a few more seconds before reporting. This is in an effort to avoid false positives on self recovering error boundary trips we have observed
    if (error) {
      reportError = setTimeout(() => {
        logger.error('ErrorBoundary - ', { error });
        fullstoryEvent('error_page_shown');
      }, 2000);
    }

    return () => {
      if (reportError) {
        clearTimeout(reportError);
      }
    };
  }, [error]);
}
